var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDeleteUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M6.667 3.333C7.402 3.333 8 3.931 8 4.667 8 5.402 7.402 6 6.667 6c-.736 0-1.334-.598-1.334-1.333 0-.736.598-1.334 1.334-1.334zm0 4c1.47 0 2.666-1.196 2.666-2.666C9.333 3.196 8.137 2 6.667 2 5.196 2 4 3.196 4 4.667c0 1.47 1.196 2.666 2.667 2.666zM13.643 5l.489-.488c.268-.27.268-.709 0-.977-.269-.269-.708-.269-.977 0l-.489.488-.488-.488c-.269-.269-.708-.269-.977 0-.268.268-.268.708 0 .977L11.69 5l-.489.488c-.268.27-.268.709 0 .977.269.269.708.269.977 0l.488-.488.49.488c.268.269.707.269.976 0 .268-.268.268-.708 0-.977L13.643 5zM2 13.333c0-2.572 2.094-4.666 4.667-4.666 2.572 0 4.666 2.094 4.666 4.666 0 .369-.298.667-.666.667-.369 0-.667-.298-.667-.667C10 11.495 8.505 10 6.667 10s-3.334 1.495-3.334 3.333c0 .369-.298.667-.666.667-.369 0-.667-.298-.667-.667z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDeleteUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_delete_user.745fd664.svg";
export { ForwardRef as ReactComponent };